import util from '@/config/util'
import {wssUrl} from '@/config/env'

var websocket = {
	ws: null,
	init: function() {
		websocket.ws = new WebSocket(wssUrl);
		websocket.ws.onopen = websocket.onOpen;
		websocket.ws.onmessage = websocket.onMessage;
		websocket.ws.onerror = websocket.onError;
		websocket.ws.onclose = websocket.onClose;
		return websocket;
	},

	onOpen: function(e) {
		websocket.heartCheck.start();
		util.removeStorage('wsInitTimes');
		console.log('webSocket init success');
	},

	onMessage: function(e) {
		websocket.heartCheck.start();
		var data = JSON.parse(e.data);
		var type = data.type;
		var result = data.data;
		switch(type) {
			case 'connect':
				if(util.getStorage('itoken') || util.isWeixin()) {
					util.request({
						url: 'kefu/bind/member',
						data: {
							client_id: result.clientId
						},
					}).then((res) => {

					})
				}
				break;
			case 'message':
				//收到消息播放音乐
				if(typeof websocket.onGetMessage == 'function') {
					websocket.onGetMessage(result);
				}
				var audio = new Audio();
				audio.src = "static/mp3/message.mp3";
				audio.play();
				break;
			case 'ping':

				break;
			default:
		}
	},

	onError: function(e) {
		//发生错误重新连接
		var wsInitTimes = util.getStorage('wsInitTimes');
		if(!wsInitTimes || !wsInitTimes.times) {
			wsInitTimes = {
				times: 0
			}
		}
		if(wsInitTimes.times < 3) {
			wsInitTimes.times++;
			util.setStorage('wsInitTimes', wsInitTimes, 5 * 60);
			websocket.init();
		}
	},

	onClose: function(e) {
		console.log('webSocket close');
	},

	onSend: function(dataObj, callback) {
		if(websocket.ws.readyState == 1) {
			websocket.ws.send(JSON.stringify(dataObj));
			if(typeof callback == 'function') {
				callback();
			}
		}
	},

	onGetMessage: null,

	heartCheck: {
		timeout: 20000,//毫秒
		timeoutObj: null,
		serverTimeoutObj: null,
		reset: function(){
			this.timeoutObj && clearTimeout(this.timeoutObj);
			this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
			return this;
		},
		start: function(){
			var self = this;
			this.reset();
			this.timeoutObj = setTimeout(function(){
				//这里发送一个心跳，后端收到后，返回一个心跳消息，
				//onmessage拿到返回的心跳就说明连接正常
				var pingData = {
					type: 'ping',
					data: {}
				};
				if(websocket.ws.readyState == 1) {
					websocket.onSend(pingData);
				}
				self.serverTimeoutObj = setTimeout(function(){//如果超过一定时间还没重置，说明后端主动断开了
					websocket.ws.close();
				}, self.timeout)
			}, this.timeout)
		}
	}

};

export default websocket;



// WEBPACK FOOTER //
// ./src/config/websocket.js